import { render, staticRenderFns } from "./NotasNivel2DadosListaConsolidado.vue?vue&type=template&id=467ba0f8&"
import script from "./NotasNivel2DadosListaConsolidado.vue?vue&type=script&lang=js&"
export * from "./NotasNivel2DadosListaConsolidado.vue?vue&type=script&lang=js&"
import style0 from "./NotasNivel2DadosListaConsolidado.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VContainer,VDataTable,VIcon,VRow,VTextField,VTooltip})
